import { useSyncExternalStore } from "react";
import { draftIsRecoverable, subscribeDrafts } from "../../lib/drafts";
import { Button } from "./Button";

export function DraftNotice({ draftKey, onDiscard, label = "Unsaved draft", discardLabel = "Discard draft" }: { draftKey: string; onDiscard: () => void; label?: string; discardLabel?: string }) {
  const recoverable = useSyncExternalStore(subscribeDrafts, () => draftIsRecoverable(draftKey));
  return <div className="draft-notice" role="status">
    <span>{recoverable ? `${label} kept in this browser. Review and save to apply your changes.` : "Draft kept for this page only. Keep it open until you save; reload recovery is unavailable."}</span>
    <Button style={{ minHeight: 44 }} data-discard-draft onPointerDown={(event) => event.preventDefault()} size="sm" variant="secondary" onMouseDown={(event) => event.preventDefault()} onClick={onDiscard}>{discardLabel}</Button>
  </div>;
}
